import { memo } from 'react'

import { usdLargeNumberFormatter } from '@repo/common/helpers/formatters'
import type { VaultSymbol } from '@repo/common/queries/products'
import { useGetVaultComposition } from '@repo/common/queries/vaults'

export const VaultTVL = memo<{ symbol: VaultSymbol }>(function VaultTVL({
  symbol,
}) {
  const { isSuccess, tvl } = useGetVaultComposition({ symbol })
  if (!isSuccess) return null
  return <>{usdLargeNumberFormatter(tvl, { maximumFractionDigits: 2 })}</>
})
